import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import ARCard from '@presentation/components/ui/ARCard/ARCard.index';
import AppSkeleton from '@presentation/components/AppSkeleton/AppSkeleton';
import EmptyCase from './components/EmptyCase/EmptyCase.index';
import { AppTableHeader, AppTableFooter, } from './AppTable.types';
import { IAppTableParams, IRenderAppTableMainParams } from './AppTable.interfaces';

export const renderAppTable = (params: IAppTableParams) => {
  console.debug('presentation/components/ui/AppTable/renderers/renderAppTable'); //DELETE

  if (params.variant === 'contained') {
    return (
      <ARCard className="artable__container">
        {renderTableContent(params)}
      </ARCard>
    );
  }

  return (
    <div className="artable__container">
      {renderTableContent(params)}
    </div>
  );
};
export const renderTableContent = (params: IAppTableParams) => {
  return (
    <>
      {renderAppTableHeader(params.header)}
      {renderAppTableMain({
        tableHeadRow: params.tableHeadRow,
        tableBodyRow: params.tableBodyRow,
        items: params.items,
        loading: params.loading,
        maxHeight: params.maxHeight,
      })}
      {!params.items?.length &&
        !params.loading &&
        <EmptyCase
          actionBtnLabel={params.emptyActionBtnLabel}
          onActionBtnClick={params.onEmptyActionBtnClick}
        />
      }
      {(params.items && !params.loading) ? renderAppTableFooter(params.footer) : null}
    </>
  );
};
export const renderAppTableHeader = (header: AppTableHeader) => {
  console.debug('presentation/components/ui/AppTable/renderers/renderAppTableHeader'); //DELETE

  if (!header) {
    return null;
  }

  return (
    <div className="artable-header">
      {header}
    </div>
  );
};
export const renderAppTableMain = (params: IRenderAppTableMainParams) => {
  console.debug('presentation/components/ui/AppTable/renderers/renderAppTableMain/params', params); //DELETE

  return (
    <div className="artable-main">
      <TableContainer sx={{ maxHeight: params.maxHeight }}>
        <Table stickyHeader className="artable-main--table">
          <TableHead className="artable-main--table__head">
            {params.tableHeadRow}
          </TableHead>

          {!!params.items?.length &&
            !params.loading &&
            <TableBody className="artable-main--table__body">
              {params.items?.map((item, index) => (
                React.cloneElement(
                  params.tableBodyRow,
                  { ...item, key: index, }
                )
              ))}
            </TableBody>
          }
        </Table>

        {params.loading &&
          <div className="artable-main__stubs">
            <AppSkeleton className="artable-main__stub" height={64} />
            <AppSkeleton className="artable-main__stub" height={64} />
            <AppSkeleton className="artable-main__stub" height={64} />
          </div>
        }
      </TableContainer>
    </div>
  );
};
export const renderAppTableFooter = (footer: AppTableFooter) => {
  console.debug('presentation/components/ui/AppTable/renderers/renderAppTableFooter'); //DELETE

  if (!footer) {
    return null;
  }

  return (
    <div className="artable-footer">
      {footer}
    </div>
  );
};